export type QueryState<T> =
  | { status: "loading" }
  | { status: "ready"; data: T }
  | { status: "error"; error: string; retry: () => void };

export function wrapQuery<TRaw, TVM>(
  raw: TRaw | undefined,
  transform: (raw: TRaw) => TVM
): QueryState<TVM> {
  if (raw === undefined) {
    return { status: "loading" };
  }
  try {
    return { status: "ready", data: transform(raw) };
  } catch (err) {
    return {
      status: "error",
      error: err instanceof Error ? err.message : "Transform failed",
      retry: () => {},
    };
  }
}

export function narrowContext<TFull, TSlice>(
  ctx: QueryState<TFull>,
  selector: (data: TFull) => TSlice
): QueryState<TSlice> {
  switch (ctx.status) {
    case "loading":
      return { status: "loading" };
    case "error":
      return { status: "error", error: ctx.error, retry: ctx.retry };
    case "ready":
      return { status: "ready", data: selector(ctx.data) };
  }
}
